import React, { Component } from 'react';
import MapView from '../../Components/Book/Map/MapView';

export default class Location extends Component {
	render() {
		return (
			<MapView />
		);
	}
}